import React, { useState, useRef } from 'react'
import DataGridAlternativa from '../../../../components/DataGridAlternativa'
import { useWindowSize, mensagens } from '../../../../util/Utilitarios.js'
import { useHistory } from 'react-router-dom'
import { FiCopy } from 'react-icons/fi'
import { mostrarToast } from '../../../../components/Toasts.js'
import { Alterar, Excluir, Visualizar } from '../../../../components/Acoes'
import { get, excluir } from '../../../../util/AcessoApi'
import { getUsuario } from '../../../../util/Configuracoes'
import { ACOES } from '../../../../util/Enums'

const ConsultaLoteLancamento = rProps => {
    console.log('rProps: ', rProps);
    const [data, setData] = useState([])
    const target = useRef(null)
    const [width] = useWindowSize()
    const history = useHistory()

    const acoesObj = [
        (propsAcao) => <Visualizar to={'/financeiro/loteLancamento/visualizacao/' + propsAcao.row.id} />,
        (propsAcao) => <Alterar to={'/financeiro/loteLancamento/alteracao/' + propsAcao.row.id} />,
        (propsAcao) => <Excluir to={'/financeiro/loteLancamento/consulta'} action={() => exclusao(propsAcao)} />,
    ]

    const exclusao = (propsAcao) => {
        const objPermissao = {
            usuario_id: getUsuario().id,
            modulo_id: rProps.modulo,
            acao_id: ACOES.EXCLUIR
        }

        get('/controleAcesso/permissao', objPermissao).then(function (val) {
            if (val.length)
                excluir('/financeiro/loteLancamento', propsAcao.row.id,
                    () => {
                        target.current.atualizar();
                        mostrarToast('sucesso', mensagens['sucesso'])
                    },
                    (e) => {
                        if (e.response && e.response.data && e.response.data.erros)
                            e.response.data.erros.forEach((item) => mostrarToast('erro', item))
                        else
                            mostrarToast('erro', mensagens.erro)
                    }, propsAcao.row.descricao_auditoria)
            else
                mostrarToast('erro', mensagens['permissao'])

        }).catch((e) => mostrarToast('erro', mensagens['erro']))
    }

    const copiarCodigoLote = (codigo) => {
        if (!codigo) return
        if (navigator?.clipboard?.writeText)
            navigator.clipboard.writeText(codigo).then(
                () => mostrarToast('sucesso', 'Código copiado!'),
                () => mostrarToast('erro', 'Não foi possível copiar o código.')
            )
        else {
            const input = document.createElement('input')
            input.value = codigo
            document.body.appendChild(input)
            input.select()
            try { document.execCommand('copy'); mostrarToast('sucesso', 'Código copiado!') }
            catch { mostrarToast('erro', 'Não foi possível copiar o código.') }
            document.body.removeChild(input)
        }
    }

    const columns = React.useMemo(
        () => [{
            id: 'consulta-lote-lancamento',
            columns: [
                {
                    Header: 'Código',
                    accessor: 'id',
                    ordenamento: {
                        tipo: 'numero',
                        ativo: true,
                        modo: 'desc',
                    }
                },
                {
                    Header: 'Código do Lote',
                    accessor: 'codigo',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    html: item => <div className='min-width-125' ><span >{item.codigo}</span>
                        <button
                            type='button'
                            className='btn btn-sm btn-outline-secondary ml-2'
                            onClick={() => copiarCodigoLote(item.codigo)}
                            title='Copiar código'
                            style={{ display: 'inline-flex', alignItems: 'center', padding: '2px 6px' }}>
                            <FiCopy />
                        </button>
                    </div>,
                    filtro: {
                        tipo: 'codigo',
                        idColuna: 'codigo'
                    }
                },
                {
                    Header: 'Estabelecimento',
                    accessor: 'estabelecimento',
                    ordenamento: {
                        tipo: 'texto'
                    },
                    filtro: {
                        tipo: 'estabelecimento_saude',
                        idColuna: 'estabelecimento_id'
                    }
                },
                {
                    Header: 'Qtd. Lançamentos',
                    accessor: 'qtd_lancamentos',
                    ordenamento: {
                        tipo: 'numero'
                    }
                },
                {
                    Header: 'Valor Total',
                    accessor: 'valor_total',
                    ordenamento: {
                        tipo: 'texto'
                    }
                },
                {
                    Header: 'Data Registro',
                    accessor: 'data_registro',
                    ordenamento: {
                        tipo: 'data'
                    }
                },
                {
                    Header: 'Data Registro Inicial',
                    accessor: 'data_inicial',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_inicial',
                        idColuna: 'data_registro_inicial',
                        datePicker: true,
                        date: true
                    }
                },
                {
                    Header: 'Data Registro Final',
                    accessor: 'data_final',
                    visivel: false,
                    ordenamento: {
                        tipo: 'data'
                    },
                    filtro: {
                        tipo: 'data_final',
                        idColuna: 'data_registro_final',
                        datePicker: true,
                        date: true
                    }
                }
            ]
        }], []
    )

    return (
        <>
            <div>
                <DataGridAlternativa
                    target={target}
                    acoesObj={acoesObj}
                    data={data}
                    columns={columns}
                    setData={setData}
                    acoes={true}
                    caminhoBase='/financeiro/loteLancamento'
                    caminhoConsultaFiltros='/financeiro/loteLancamentoPaginacao'
                    modulo={rProps.modulo}
                    titulo={'Consulta Lote de Lançamentos'}
                    tituloLista={'Lista de Lotes de Lançamentos'}
                    urlCadastro='/financeiro/loteLancamento/cadastro'
                    icone={'icon-Folder-WithDocument'}
                />
            </div>
        </>
    )
}

export default ConsultaLoteLancamento
